import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import UserManagement from './UserManagement.tsx';
import AdminStats from './Stats';
import AdminGuard from '../../components/guards/AdminGuard';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  };
}

const AdminDashboard = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <AdminGuard>
      <Box sx={{ width: '100%', mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold', mb: 3 }}>
          Administration
        </Typography>
        
        <Paper sx={{ width: '100%', borderRadius: 2 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              value={tabValue} 
              onChange={handleTabChange} 
              aria-label="admin tabs"
              sx={{
                '& .MuiTab-root': {
                  fontWeight: 600,
                  fontSize: '0.95rem',
                }
              }}
            >
              <Tab label="Gestion des utilisateurs" {...a11yProps(0)} />
              <Tab label="Statistiques" {...a11yProps(1)} />
              <Tab label="Configuration" {...a11yProps(2)} disabled />
            </Tabs>
          </Box>
          
          <TabPanel value={tabValue} index={0}>
            <UserManagement />
          </TabPanel>
          
          <TabPanel value={tabValue} index={1}>
            <AdminStats />
          </TabPanel>
          
          <TabPanel value={tabValue} index={2}>
            <Typography variant="body1">Configuration (à venir)</Typography>
          </TabPanel>
        </Paper>
      </Box>
    </AdminGuard>
  );
};

export default AdminDashboard;
